<template>
    <div class="relative flex flex-col max-w-screen-xl mx-auto pl-5 lg:pl-12 pr-5 py-5 lg:py-12">
        <regions-modal></regions-modal>

        <lead-header>
            Please describe your legal matter so the lawyer can serve you better
        </lead-header>

        <div class="mt-6">
            <p class="text-xs text-right text-neutral-400" :class="{ 'error-text' : form.errors.has('issue') }">
                {{ charactersRemaining }} characters remaining.
            </p>

            <textarea
                class="w-full h-48 p-4 mt-2 bg-white border border-zinc-300 rounded-lg focus:outline-brand-blue"
                :class="{ 'border-red-500 focus:outline-red-500' : form.errors.has('issue') }"
                id="issue"
                ref="issue"
                name="issue"
                placeholder="Just a few words or a single sentence works fine…"
                :maxlength="validation.issue.max"
                :minlength="validation.issue.min"
                data-hj-allow
                v-model="form.issue"
                @keydown="form.errors.clear($event.target.name)"
            ></textarea>
        </div>

        <div v-if="form.errors.has('issue')" class="pb-4 text-center text-red-500" role="alert">
            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>

            <span class="sr-only">
                Error:
            </span>

            {{ form.errors.get('issue') }}
        </div>

        <div class="mt-5 lg:mt-6 flex flex-col lg:flex-row justify-between w-full items-center">
            <previous-button></previous-button>

            <next-button
                id="btn-lead-capture-step-2"
                @click.native="submit"
                :disabled="form.errors.has('issue')"
            >
                Continue
            </next-button>
        </div>
        <TrustpilotMicroCombo/>
    </div>
</template>

<script>
import { set } from 'lodash';
import { mapGetters } from 'vuex';

import PreviousButton from './PreviousButton.vue';
import NextButton from './NextButton.vue';
import BaseButton from '../BaseButton.vue';
import LeadHeader from './LeadHeader.vue';
import RegionsModal from './RegionsModal.vue';
import TrustpilotMicroCombo from "./TrustpilotMicroCombo.vue";


export default {
    components: {
        PreviousButton,
        NextButton,
        BaseButton,
        LeadHeader,
        RegionsModal,
        TrustpilotMicroCombo
    },
    props: {
        validation: {
            type: Object,
            required: true,
        }
    },

    computed: {
        ...mapGetters('lead', [
            'form',
            'locationId',
            'regions'
        ]),

        /**
         * @returns {number}
         */
        charactersRemaining () {
            return this.validation.issue.max - this.form.issue.length;
        }
    },

    methods: {
        /**
         * Check if form is valid and set respective errors if needed.
         *
         * @returns {boolean}
         */
        formIsValid() {
            if (! this.form.issue) {
                this.$set(this.form.errors.errors, 'issue', ['The issue description is required.']);

                return false;
            }

            if (this.form.issue.length < this.validation.issue.min || this.form.issue.length > this.validation.issue.max) {
                this.$set(this.form.errors.errors, 'issue', [`The issue description must be between ${this.validation.issue.min} and ${this.validation.issue.max} characters.`]);

                return false;
            }

            if (this.form.issue.split(' ').length < 2) {
                this.$set(this.form.errors.errors, 'issue', ['The issue description must contain at least two words.']);

                return false;
            }

            return true;
        },

        /**
         * Record necessary location information in local storage.
         */
        recordInLocalStorage() {
            let form = JSON.parse(window.localStorage.getItem('lcsForm'));

            set(form, 'issue', this.form.issue);

            window.localStorage.setItem('lcsForm', JSON.stringify(form));
        },

        /**
         * Record data in localStorage and fire event that this step is done.
         */
        submit() {
            if (this.formIsValid()) {
                this.form.errors.clear('issue');

                this.recordInLocalStorage();

                window.dataLayer.push({
                    event: 'form_step_submit',
                    form_step_id: window.getCurrentStep(),
                    form_step_name: 'issue'
                });

                this.$event.$emit('step:next');
            }
        },

        focusIssueInput () {
            window.scrollTo({ top: 0, behavior: "instant" });

            window.setTimeout(() => {
                this.$refs.issue.focus();
            }, 100);
        },
    },

    mounted() {
        this.focusIssueInput();

        window.dataLayer.push({
            event: 'form_step_mounted',
            form_step_id: window.getCurrentStep(),
            form_step_name: 'issue'
        });
    }
};
</script>
